import { Box } from '../../../box';
import { Row } from '../../../row';
import { Cell } from '../../../cell';
import { UserLookup } from '../../../lookups';
import { SingleSelect } from '../../../single-select';
import { AssociateUserRole, AssociatedCaseWorkerModel } from '../../../../api-service/clients';
import { compareStringsAsLowerCase } from '../../../../utilities/string-helper';
import { DatePicker, DatePickerValue } from '../../../date-picker';
import { MaxLengthTextField } from '../../../text-field';
import React from 'react';
import { FormDialog } from '../../../form-dialog';
import { toStartOfDay } from '../../../../utilities';
import { CheckBox } from '@mui/icons-material';
import { Checkbox, FormControlLabel } from '@mui/material';

interface IAssignAssociatedcaseworkerCasesComponentProps {
  associateUserRoles: AssociateUserRole[];
  errors: AssociatedCaseWorkerModel;
  associatedCaseWorker: AssociatedCaseWorkerModel;
  isOpen: boolean;
  isLoading: boolean;
  minStartDate?: Date;
  maxEndDate?: Date;
  caseStartEndChecked: boolean;
  onAssociateUserRoleChange: (value: AssociateUserRole) => void;
  onStartDateChange: (value: DatePickerValue) => void;
  onEndDateChange: (value: DatePickerValue) => void;
  onDescriptionChange: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
  onUserChange: (value: string | undefined) => void;
  onClose: () => void;
  onConfirm: () => void;
  onCaseStartEndClicked: (value: boolean) => void;
}
export function AssignAssociatedcaseworkerCasesComponent(props: IAssignAssociatedcaseworkerCasesComponentProps) {
  const {
    isLoading,
    onClose,
    isOpen,
    associatedCaseWorker,
    onAssociateUserRoleChange,
    onStartDateChange,
    onEndDateChange,
    onDescriptionChange,
    onUserChange,
    associateUserRoles,
    errors,
    onConfirm,
    minStartDate,
    maxEndDate,
    caseStartEndChecked,
    onCaseStartEndClicked,
  } = props;
  const { caseWorkerId, role, description } = associatedCaseWorker;

  return (
    <FormDialog
      open={isOpen}
      title="Tilføj supplerende sagsbehandler til de valgte sager"
      confirmButtonText="Udfør"
      cancelButtonText="Afbryd"
      isLoading={isLoading}
      onConfirmClick={onConfirm}
      onClose={onClose}
      onCancelClick={onClose}
      maxWidth="lg"
      isValid
    >
      <Box mt={1}>
        <Row>
          <Cell size="half">
            <UserLookup label="Sagsbehandler" onChange={onUserChange} required value={caseWorkerId} error={!!errors.caseWorkerId} errorText={errors.caseWorkerId} />
          </Cell>
          <Cell size="half">
            <SingleSelect<AssociateUserRole>
              label="Rolle"
              variant="outlined"
              onChange={onAssociateUserRoleChange}
              value={associateUserRoles?.find(cg => cg.id === role)}
              options={associateUserRoles?.sort((a: AssociateUserRole, b: AssociateUserRole) => compareStringsAsLowerCase(a.name || '', b.name || '')) ?? []}
              isOptionEqualToValue={(option, val) => option.id === val.id}
              getOptionLabel={(option: AssociateUserRole) => option.name ?? ''}
              renderOption={(renderProps: object, option: AssociateUserRole) => (
                <li {...renderProps} key={option.id}>
                  {option.name ?? ''}
                </li>
              )}
            />
          </Cell>
        </Row>

        {!caseStartEndChecked && (
          <Row>
            <Cell size="half">
              <DatePicker
                label="Startdato"
                onChange={onStartDateChange}
                minDate={toStartOfDay(minStartDate)}
                maxDate={maxEndDate ? toStartOfDay(maxEndDate) : undefined}
                value={minStartDate}
                variant="outlined"
                fullWidth
                error={!!errors.startDate}
                errorText={errors.startDate}
              />
            </Cell>
            <Cell size="half">
              <DatePicker
                label="Slutdato"
                onChange={onEndDateChange}
                minDate={toStartOfDay(minStartDate)}
                maxDate={maxEndDate ? toStartOfDay(maxEndDate) : undefined}
                value={maxEndDate}
                variant="outlined"
                fullWidth
                error={!!errors.endDate}
                errorText={errors.endDate}
              />
            </Cell>
          </Row>
        )}
        <Row>
          <Cell size="full">
            <MaxLengthTextField onChange={onDescriptionChange} maxLength={200} minRows="5" variant="outlined" multiline fullWidth label="Beskrivelse" value={description || ''} />
          </Cell>
        </Row>
        <Row>
          <Cell size="full" style={{ paddingTop: '0px' }}>
            <FormControlLabel
              control={<Checkbox checked={caseStartEndChecked} onChange={e => onCaseStartEndClicked(e.target.checked)} name="isActive" />}
              label="Sæt start- og slutdato på supplerende sagsbehandler til sagernes start- og slutdato"
            />
          </Cell>
        </Row>
      </Box>
    </FormDialog>
  );
}
